export default function Footer() {
  return (
    <footer
      data-testid="footer-section"
      className="px-6 sm:px-12 lg:px-20 pt-24 pb-12"
    >
      <div className="grid grid-cols-12 gap-8 items-end">
        <div className="col-span-12 md:col-span-5">
          <p className="font-serif font-light text-2xl sm:text-3xl text-white tracking-tight">
            Oksana O'Donnell
          </p>
          <p data-testid="footer-location" className="mt-3 text-[11px] uppercase tracking-[0.3em] text-white/40">
            New York City &amp; Hamptons
          </p>
        </div>
        <div className="col-span-12 md:col-span-4 flex flex-col gap-3 text-sm font-light">
          <a
            data-testid="footer-email-link"
            href="mailto:oksana@chefoksana.com"
            className="text-white/70 transition-opacity duration-300 hover:opacity-50 w-fit"
          >
            oksana@chefoksana.com
          </a>
          <a
            data-testid="footer-phone-link"
            href="tel:+19179945717"
            className="text-white/70 transition-opacity duration-300 hover:opacity-50 w-fit"
          >
            +1 917 994 5717
          </a>
          <a
            data-testid="footer-instagram-link"
            href="https://bit.ly/4xPsIa7"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/70 transition-opacity duration-300 hover:opacity-50 w-fit"
          >
            Instagram
          </a>
        </div>
        <div className="col-span-12 md:col-span-3 md:text-right">
          <a
            data-testid="footer-domain-link"
            href="https://chefoksana.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[11px] uppercase tracking-[0.3em] text-white/40 transition-opacity duration-300 hover:opacity-70"
          >
            chefoksana.com
          </a>
        </div>
      </div>
      <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4">
        <p data-testid="footer-copyright" className="text-[11px] tracking-[0.2em] text-white/30">
          © 2026 Oksana O'Donnell. All rights reserved.
        </p>
        <p className="text-[11px] tracking-[0.2em] text-white/30">
          Private Chef — By Referral &amp; Inquiry
        </p>
      </div>
    </footer>
  );
}
